import { FieldContext } from "./chunk-57D4P5XD.js";
import { ValidationMessage_default } from "./chunk-ZQDBVQVV.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Field/Field.ValidationMessage.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var FIELD_VALIDATION_MESSAGE_CLASSNAME_MAP = {};
var FieldValidationMessage = _a => {
  var _b = _a,
    {
      role = "alert",
      className
    } = _b,
    rest = __objRest(_b, ["role", "className"]);
  const {
    id,
    validation,
    validationMessage
  } = useContext(FieldContext);
  if (!validationMessage) {
    return null;
  }
  return /* @__PURE__ */jsx(ValidationMessage_default, __spreadProps(__spreadValues({
    variant: validation,
    id: "".concat(id, "-validation"),
    role,
    className: clsx("pd:field__validation-message", className)
  }, rest), {
    children: validationMessage
  }));
};
var Field_ValidationMessage_default = FieldValidationMessage;
export { FIELD_VALIDATION_MESSAGE_CLASSNAME_MAP, Field_ValidationMessage_default };